<template>
  <c-button ref="button" :style="computedStyle" v-bind="$props"></c-button>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin } from '@tencent/ceiba-base-components';
import button from '@tencent/ceiba-act-public-button';

const NOTSIGN = 0;
const SIGNED = 1;
const RESIGN = 2;
export default {
  name: 'CButtonSign',
  components: {
    [button.name]: button,
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'button-sign-',
      signFlag: NOTSIGN,
    };
  },
  computed: {
    computedStyle() {
      let backgroundImg = this.configurationData.signImg;
      const { isStretching } = this.configurationData;
      if (this.signFlag === SIGNED) {
        backgroundImg = this.configurationData.signedImg;
      } else if (this.signFlag === RESIGN) {
        backgroundImg = this.configurationData.reSignImg;
      }
      console.log('backgroundImg=', backgroundImg);
      return {
        backgroundImage: `url("${encodeURI(backgroundImg)}")`,
        backgroundSize: isStretching ? '' : 'contain', // 是否拉伸
        backgroundRepeat: 'no-repeat',
      };
    },
  },
  mounted() {
    console.log('configurationData=', this.configurationData);
    this.initialize();
  },
  methods: {
    initialize() {
      const self = this;
      this.$onLogined(() => {
        self.initStatus();
      });
      this.$refs.button.setClickHandler(this.handleClick, {
        forceApp: this.configurationData.forceApp,
        forceLogin: true,
        forceRole: this.configurationData.needBindRole,
      });
    },
    async initStatus() {
      console.log('initStatus');
      if (!this.configurationData.checkFlowID) return;

      // const response = await this.flowRequest({ flowId: this.configurationData.checkFlowID });
      const response = await this.flowRequest({
        flowId: this.configurationData.checkFlowID,
        params: {
          role: this.roleInfo,
        },
      });
      if (response.ret === 0 && response.data.ret === 0) {
        this.signFlag = SIGNED;
      } else if (response.ret === 0 && response.data.ret === 9001 && !!response.data.date) {
        if (
          parseInt(this.getCurrentDate(), 10) > parseInt(response.data.date, 10)
          && !!this.configurationData.reSignFlowID
        ) {
          // 补签
          this.signFlag = RESIGN;
          return;
        }
      } else {
        this.signFlag = NOTSIGN;
      }
      console.log('initStatus = ', this.signFlag);
    },
    getCurrentDate() {
      const time = new Date();
      return `${time.getFullYear()}${time.getMonth() + 1 > 9 ? time.getMonth() + 1 : '0'.concat(time.getMonth() + 1)}${
        time.getDate() > 9 ? time.getDate() : '0'.concat(time.getDate())
      }`;
    },
    async handleClick() {
      this.reportClick({
        ceibaComponentId: `${this.cid}`,
        ceibaComponentUid: this.uid,
        ceibaComponentUname: this.uname,
      });

      if (this.signFlag === SIGNED) return;

      let flowID = this.configurationData.signFlowID;
      if (this.signFlag === RESIGN) {
        // 补签
        flowID = this.configurationData.reSignFlowID;
      }
      if (flowID) {
        const response = await this.flowRequest({
          flowId: flowID,
          params: {
            role: this.roleInfo,
          },
        });
        console.log('response=', response);


        if (response.ret === 0 && response.data.ret === 0) {
          console.log('sign success');
          let text = this.configurationData.signSuccessText || '';
          // 如果没有配置签到提示信息 则获取返回信息
          if (typeof text === 'string' && text.length === 0) {
            const { msg = '', data = {} } = response;
            const { msg: resMsg } = data;
            text = resMsg || msg || '签到成功！';
            text = text.replace('您', '你');
          }
          this.alert(text);
          this.reportClickRaw({
            ceibaComponentId: `${this.cid}`,
            ceibaComponentUid: this.uid,
            ceibaComponentUname: this.uname,
            eventKey: 'sign_in',
            eventData: {
              status: '1',
            },
          });
          this.refreshQua(); // 刷新礼包
        } else {
          this.alert(response.msg);
          this.reportClickRaw({
            ceibaComponentId: `${this.cid}`,
            ceibaComponentUid: this.uid,
            ceibaComponentUname: this.uname,
            eventKey: 'sign_in',
            eventData: {
              status: '0',
            },
          });
        }
      }
      this.initStatus();
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
